
import React from 'react'
import './approveOrRejectActionPage.css';
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { processWorkFlow } from './workListAPIs'
import { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Container, Stack, Box, Typography, Grid, FormControl, TextField } from '@mui/material';
import BackButton from '../../../common/backButton';
import { VALIDATION, capitalizeFunction, openTextFieldMaxLength } from '../../../common/commonValidations';
import { DataGrid } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

function ApproveOrRejectActionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const { state } = useLocation();
  const [comment, setComment] = useState();
  const [processedWorkFlowResponse, setProcessedWorkFlowResponse] = useState();
  const workflowdetails = state?.workflowdtl;
  useEffect(() => {
    if (processedWorkFlowResponse) {
      if(processedWorkFlowResponse?.status === "SUCCESS") {
        toast.success(processedWorkFlowResponse?.description);
        if (localStorage.getItem('urn')) {
          navigate('/dashboardHome/dashboardStakeHolder')
        }
        else navigate('../home');
        // navigate('../home');
      }
        else toast.error(processedWorkFlowResponse?.description)
    }
  }, [processedWorkFlowResponse]);

  const handleChange = (e) => {
    setComment(VALIDATION.noSpecialCharacterValidation(e.target.value))
  }

  const commentColumns = [
    { field: 'previousStepUser', headerName: "User", width: 300 },
    { field: 'previousStepComments', headerName: "Comment", width: 650 },
]

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES13</p>}
        <Grid item xs={12} lg={8}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <BackButton navigate={navigate} />
          <Typography variant="h5" gutterBottom>
          Approval Section
          </Typography>
          </Stack>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={8} hidden={state?.category === "actionTaken"}>
            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
              <TextField fullWidth
                multiline
                maxRows={5}
                inputProps={{
                  maxLength: openTextFieldMaxLength,
                  // style: { textTransform: "capitalize" }
              }}
                rows={2}
                value={comment}
                label="Add Comment"
                onChange={(e) => handleChange(e)}
                sx={{ mt: 2 }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="h6">
                            {t('reg.commentHistory')}
                        </Typography>
                    <DataGrid autoHeight
                                rows={workflowdetails?.workflowCommentHistory ? workflowdetails?.workflowCommentHistory.map((commentItem) => ({...commentItem, id: uuidv4()})) : []}
                                columns={commentColumns}
                                pageSize={10}
                                // getRowId={(row) => row?.applicationNumber}
                            />
                            </Grid>
        </Grid>
       <Grid item xs={12} md={12} spacing={1} display='flex' justifyContent="flex-end" hidden={state?.category === "actionTaken"}>
          {
          (workflowdetails?.previousStepAction === 'Seek_Clarification')
            ?
            <Button sx={{ minWidth: 100 , ml:2, mt:5}} variant="contained" type='submit' value='submit' onClick={() => processWorkFlow(state?.selectedApplicationNumber, state?.type === "plant" ? "Plantation_Clarification" : "Mapping_Clarification", comment, setProcessedWorkFlowResponse)}>Provide Clarification</Button>
            :
            <><Button sx={{ minWidth: 100 , ml:2, mt:5}} variant="contained" type='submit' value='submit' onClick={() => processWorkFlow(state?.selectedApplicationNumber, "Seek_Clarification", comment, setProcessedWorkFlowResponse)}>Seek Clarification</Button>
              <Button sx={{ minWidth: 100 , ml:2, mt:5}} variant="contained" type='submit' value='submit' onClick={() => processWorkFlow(state?.selectedApplicationNumber, "Approved", comment, setProcessedWorkFlowResponse)}>Approve</Button>
              <Button sx={{ minWidth: 100 , ml:2, mt:5}} variant="contained" type='submit' value='submit' onClick={() => processWorkFlow(state?.selectedApplicationNumber, "Rejected", comment, setProcessedWorkFlowResponse)}>Reject</Button></>
        }
        </Grid>
      </Container>
    </>
  )
}

export default ApproveOrRejectActionPage;